"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var custom_sizes_directives_1 = require("./custom-sizes-directives");
exports.ShowItSizes = custom_sizes_directives_1.ShowItSizes;
exports.HideItSizes = custom_sizes_directives_1.HideItSizes;
exports.CUSTOMSIZES_DIRECTIVES = [
    custom_sizes_directives_1.ShowItSizes,
    custom_sizes_directives_1.HideItSizes
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/ng2-responsive/custom-sizes/index.js
// module id = RVcy
// module chunks = 6